import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useParams } from 'react-router';
import { CardSmallGrid } from '../core/card/CommonCardLayouts';
import LicenseExpiredBannerCard from '../license/LicenseExpiredBannerCard';
import SplashLoader from '../loading/SplashLoader';
import OrgBillingComponents from './billing/OrgBillingComponents';
import OrgGovernanceCard from './governance/OrgGovernanceCard';
import OrgInvitesCard from './invite/OrgInvitesCard';
import LicenseKeyCard from './licenseKey/LicenseKeyCard';
import ManagedOrgCard from './managedOrg/ManagedOrgCard';
import OrgMemberCard from './member/OrgMemberCard';
import OrgProfilesCard from './OrgProfilesCard';
import OrgProductLandingCard from './product/OrgProductLandingCard';
import OrgProjectsCard from './projects/OrgProjectsCard';
import OrgSettingsCard from './settings/OrgSettingsCard';

interface IOrgPageContentProps {
    isAdminPortal?: boolean;
}

export default function OrgPageContent({ isAdminPortal = false }: IOrgPageContentProps) {
    const {
        canAccessOrganizationProfiles,
        canCreateAuthClients,
        canEditOrganizationProfiles,
        canInviteMembers,
        canManageBilling,
        canManageChildOrganizations,
        canManageGovernance,
        canViewMembers,
        canViewOrgDetails,
        currentOrg,
        hasSomeMemberEditPermissions,
        isExpiredOrg,
        isLoading,
        isManagedOrg,
    } = useCurrentOrgDetailsFetching();
    const { managedOrgId } = useParams();

    if (!currentOrg) return null;
    if (isLoading) return <SplashLoader />;
    if (isExpiredOrg)
        return (
            <LicenseExpiredBannerCard
                organizationId={currentOrg.id}
                canManageBilling={canManageBilling}
                isManagedOrg={isManagedOrg}
                customBillingUrl={currentOrg.customBillingUrl}
            />
        );

    if (!canViewOrgDetails) {
        return (
            <CardSmallGrid>
                <OrgBillingComponents currentOrg={currentOrg} canManageBilling={canManageBilling} />
            </CardSmallGrid>
        );
    }

    return (
        <>
            {(canViewMembers || hasSomeMemberEditPermissions) && <OrgMemberCard orgId={currentOrg.id} />}
            {canInviteMembers && <OrgInvitesCard orgId={currentOrg.id} />}
            {(canAccessOrganizationProfiles || canEditOrganizationProfiles) && isAdminPortal && (
                <OrgProfilesCard orgId={currentOrg.id} />
            )}

            {/* {(currentOrg.canCreateAuthClients || currentOrg.isAdmin) && (
                    <OrgMetricsCard orgId={currentOrg.organizationId} />
                )} */}

            {canManageGovernance && isAdminPortal && <OrgGovernanceCard orgId={currentOrg.id} />}

            {!managedOrgId && currentOrg.isReseller && canManageChildOrganizations && isAdminPortal && (
                <>
                    <ManagedOrgCard orgId={currentOrg.id} />
                    <LicenseKeyCard orgId={currentOrg.id} />
                    <OrgProductLandingCard orgId={currentOrg.id} />
                    {/* <OrgLicenseKeyCard orgId={currentOrg.organizationId} /> */}
                </>
            )}
            {canCreateAuthClients && isAdminPortal && (
                <OrgProjectsCard orgId={currentOrg.id} projects={currentOrg.canCreateAuthClients} />
            )}
            <OrgSettingsCard orgId={currentOrg.id} />
        </>
    );
}
